/*
* Copyright (C) SiteVision AB 2002-2025, all rights reserved
*
* @author robin
*/
import sv from '@sv/core';
import $ from '@sv/jquery';
import {
   DialogUtil as dialogUtil,
   i18n as _i18n,
} from '@sv/util';

const
   i18nCommon = function(key, args) {
      return _i18n.getText('common', key, args);
   },
   i18cache = {};

// HELPERS ----------------------------------------------------
const i18n = function(selector, args) {
   let translated;

   if (!args && i18cache[selector]) {
      return i18cache[selector];
   }

   translated = _i18n.getText('portlet.social.profileprogress.profileprogress', selector, args);

   if (!args) {
      i18cache[selector] = translated;
   }
   return translated;
},
createModalContent = function(portletSettings) {

   var buttons = [{
      text: i18nCommon('ok'),
      primary: true
   }];

   var $modalContent = $('<div/>'),
      $dl;

   if (portletSettings.descriptiveText) {
      $modalContent.append('<p>' + portletSettings.descriptiveText + '</p>');
   }

   var profileCriteria = $.extend(portletSettings.profileCriteria, portletSettings.fields);

   if (profileCriteria && !$.isEmptyObject(profileCriteria)) {
      $modalContent.append('<h3 class="modal-section-title">'+ i18n('profileCriteria') +'</h3>');
      $dl = $('<dl/>');
      $.each(profileCriteria, function(k,v) {
         if (v) {
            $dl.append('<dt class="sv-has-value"><span class="halflings-icon ok"></span><span aria-hidden="true">' + i18n(k) + '</span><span class="env-assistive-text">' + i18n(k) + ', ' + i18n('done') + '</span></dt>');
         } else {
            var text = k === 'hasProfileImage' ? i18n('incomplete') : i18n('missingValue');
            $dl.append('<dt class="sv-no-value"><span class="halflings-icon remove sv-no-value"></span><span aria-hidden="true">' + i18n(k) + '</span><span class="env-assistive-text">' + i18n(k) + ', ' + i18n(text) + '</span></dt>');
            $dl.append('<dd aria-hidden="true">'+ text +'</dd>');
         }
      });
      $modalContent.append($dl);
   }

   if (portletSettings.collaborationCriteria && !$.isEmptyObject(portletSettings.collaborationCriteria)) {
      $modalContent.append('<h3 class="modal-section-title">'+ i18n('collaborationCriteria') +'</h3>');
      $dl = $('<dl/>');
      $.each(portletSettings.collaborationCriteria, function(k,v) {
         if (v) {
            $dl.append('<dt class="sv-has-value"><span class="halflings-icon ok"></span><span aria-hidden="true">' + i18n(k) + '</span><span class="env-assistive-text">' + i18n(k) + ', ' + i18n('done') + '</span></dt>');
         } else {
            $dl.append('<dt class="sv-no-value"><span class="halflings-icon remove sv-no-value"></span><span aria-hidden="true">' + i18n(k) + '</span><span class="env-assistive-text">' + i18n(k) + ', ' + i18n('incomplete') + '</span></dt>');
            $dl.append('<dd aria-hidden="true">'+ i18n('incomplete') +'</dd>');
         }
      });
      $modalContent.append($dl);
   }

   if (portletSettings.helpPageUrl) {
      $modalContent.append('<a href="'+ portletSettings.helpPageUrl +'">'+i18n('helpPage')+'</a>');
   }

   $('dl', $modalContent).addClass('sv-clearfix env-m-around--0');
   $('dd', $modalContent).addClass('sv-float-left');
   $('dt', $modalContent).addClass('sv-float-left').addClass('sv-clear-left');
   $('h3', $modalContent).addClass('sv-clear-left');

   var content = {
      content: $modalContent,
      buttons: buttons
   };

   return content;
};

function openDialog (element) {
   var $this = $(element);
   if ($this.parent().is('[data-portlet-type]')) {
      return false; //Dont show popup in edit mode
   }

   var jsNamespace = $this.data('js-namespace'),
      portletSettings = sv[jsNamespace],
      modalContent = createModalContent(portletSettings);

   dialogUtil.showDialog({
      title: i18n('profileProgress'),
      body: modalContent.content,
      buttons: modalContent.buttons,
      removeOnHide: true
   });
}

$('.sv-profileprogress-portlet').on('click','.sv-profile-progress', function() {
   openDialog(this);
});
$('.sv-profileprogress-portlet').on('keydown','.sv-profile-progress', function(e) {
   const code = e.originalEvent.code;
   if (code === 'Space' || code === 'Enter') {
      openDialog(this);
   }
});
